import React from "react";
import { Target } from "lucide-react";
import { ContractKpiCard } from "./ContractKpiCard";

export function KpisTab({ contractKpis, contractId, fetchData, expanded }) {
  if (!contractKpis || contractKpis.length === 0) {
    return (
      <div className="text-center py-8 space-y-2" data-testid="no-kpis-message">
        <Target size={32} className="mx-auto text-slate-300" />
        <p className="text-sm text-slate-500">No KPIs defined for this contract.</p>
        <p className="text-xs text-slate-400">KPIs can be added when creating or editing the contract using the AI extraction tool or manual entry in the contract editor.</p>
      </div>
    );
  }

  const avg = Math.round(contractKpis.reduce((s, k) => s + (k.completion_pct || 0), 0) / contractKpis.length);
  const color = avg >= 80 ? "text-emerald-600" : avg >= 50 ? "text-amber-600" : "text-red-600";

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Target size={14} className="text-cyan-600" />
          <p className="text-sm font-medium text-slate-700 dark:text-slate-300">Performance Assessment</p>
          <span className="text-xs text-slate-400">({contractKpis.length} KPIs)</span>
        </div>
        <span className={`text-sm font-bold ${color}`} data-testid="kpi-avg-completion">Avg: {avg}%</span>
      </div>
      <div className={`space-y-2 overflow-y-auto ${expanded ? "max-h-[calc(100vh-350px)]" : "max-h-[450px]"}`}>
        {contractKpis.map((kpi) => (
          <ContractKpiCard key={kpi.id} kpi={kpi} contractId={contractId} onUpdate={fetchData} />
        ))}
      </div>
    </div>
  );
}
